import { type Currency, CURRENCIES, DEFAULT_CURRENCY } from './constants/currency';

const CURRENCY_LOCALE_FALLBACK: Record<Currency, string> = {
  EUR: 'fr-FR',
  USD: 'en-US',
};

export function isCurrency(value: unknown): value is Currency {
  return typeof value === 'string' && (CURRENCIES as readonly string[]).includes(value);
}

export function formatMoney(
  amount: number,
  currency: Currency = DEFAULT_CURRENCY,
  options: { locale?: string; minimumFractionDigits?: number; maximumFractionDigits?: number } = {},
): string {
  const locale = options.locale ?? CURRENCY_LOCALE_FALLBACK[currency];
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: options.minimumFractionDigits ?? 2,
    maximumFractionDigits: options.maximumFractionDigits ?? 2,
  }).format(amount);
}

export function roundUpToCent(amount: number): number {
  return Math.ceil(amount * 100) / 100;
}

export interface ExchangeRate {
  base: Currency;
  quote: Currency;
  rate: number;
  fetchedAt: Date;
}

export class CurrencyConversionUnavailableError extends Error {
  constructor(base: Currency, quote: Currency) {
    super(`Exchange rate ${base}->${quote} is currently unavailable`);
    this.name = 'CurrencyConversionUnavailableError';
  }
}

export interface ExchangeRateProvider {
  fetchRate(base: Currency, quote: Currency): Promise<ExchangeRate>;
}

export function applyExchangeRate(amount: number, rate: ExchangeRate): number {
  return roundUpToCent(amount * rate.rate);
}
